import { render, staticRenderFns } from "./C2wClicksByTitleBarChart.vue?vue&type=template&id=4252ef78&scoped=true&"
import script from "./C2wClicksByTitleBarChart.vue?vue&type=script&lang=js&"
export * from "./C2wClicksByTitleBarChart.vue?vue&type=script&lang=js&"
import style0 from "./C2wClicksByTitleBarChart.vue?vue&type=style&index=0&id=4252ef78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252ef78",
  null
  
)

export default component.exports